/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationInvitationStatusSchema } from "./organizationInvitationStatusSchema.ts";
import { goodLuckCoreEntitiesOrganizationSchema } from "./organizationSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationInvitationSchema = z.object({
  id: z.optional(z.uuid()),
  organizationId: z.uuid(),
  get organization() {
    return goodLuckCoreEntitiesOrganizationSchema.optional();
  },
  inviterId: z.string().min(1),
  get inviter() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  inviteeId: z.string().min(1),
  get invitee() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  roleId: z.int(),
  get status() {
    return goodLuckCoreEntitiesOrganizationInvitationStatusSchema;
  },
  createdAt: z.optional(z.iso.datetime()),
  expiresAt: z.iso.datetime().nullish(),
});
